<template>
  <div class="content_container">
    <div class="container_left">
      <div class="title">
        <p>{{ sideNavObj.val }}</p>
        <p>{{ sideNavObj.englishVal }}</p>
      </div>
      <ul v-if="sideNavObj.children.length > 0">
        <li
          v-for="(item, idx) in sideNavObj.children"
          :key="idx"
          :class="{ active: item.val === menuName }"
          @click="tabChange(item.val)"
        >
          {{ item.val }}
        </li>
      </ul>
    </div>
    <div class="container_right">
      <div class="title">
        <p class="text">{{ menuName }}</p>
        <div class="breadcrumb">
          <i class="iconfont icon-shouye"></i>
          <span>您当前所在位置：</span>
          <span class="item" @click="goHome">首页</span>
          <span class="item" @click="tabChange('党群工作')">
            党群工作
          </span>
          <span
            class="item"
            v-if="menuName !== '党群工作'"
            @click="tabChange(menuName)"
            >{{ menuName }}</span
          >
        </div>
      </div>
      <div class="detail" v-if="!!detailData">
        <h3 class="detail_title">
          {{ detailData.mainTitle }}
        </h3>
        <div class="detail_info">
          <p>
            {{
              `发布时间：${moment(detailData.publishTime).format("YYYY-MM-DD")}`
            }}
          </p>
          <p>
            {{ `发布人：${detailData.publishMan}` }}
          </p>
          <p>浏览次数：{{ detailData.click }}</p>
        </div>
        <div class="detail_con">
          <div class="ql-container">
            <div class="ql-editor" v-html="detailData.content"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      moment,
      menuName: "",
      sideNavObj: {
        val: "党群工作",
        englishVal: "PARTY WORK",
        children: [
          {
            val: "组织简介",
          },
          {
            val: "党风廉政",
          },
          {
            val: "支部建设",
          },
          {
            val: "工会活动",
          },
          {
            val: "职工风采",
          },
        ],
      },

      detailData: null,
    };
  },
  watch: {
    $route(val) {
      this.menuName = val.query.current || "党群工作";
    },
  },
  created() {
    this.menuName = this.$route.query.current || "党群工作";
    let id = this.$route.query.id;
    this.getDetail(id);
  },
  methods: {
    tabChange(menuName) {
      this.$router.push({
        path: "/work",
        query: {
          current: menuName,
        },
      });
    },
    getDetail(id) {
      let data = { id };

      this.$api.getArcDetail(data).then((res) => {
        this.detailData = res.data;
      });
    },
    goHome() {
      this.$router.push("/home");
    },
  },
};
</script>

<style lang="scss" scoped>
.content_container {
  width: 1110px;
  margin: 0 auto;
  padding-top: 20px;
  display: flex;
  .container_left {
    width: 230px;
    display: flex;
    flex-direction: column;
    margin-right: 20px;
    flex-shrink: 0;
    .title {
      height: 90px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background-color: #a13838;
      p {
        color: #fff;
        font-size: 12px;
        &:first-child {
          margin-bottom: 5px;
          font-size: 20px;
        }
      }
    }
    ul {
      flex: 1;
      border: 1px #efefef solid;
      li {
        padding: 15px 0;
        text-align: center;
        color: #666;
        border-bottom: 1px #efefef solid;
        position: relative;
        cursor: pointer;
        &:hover,
        &.active {
          color: #a13838;
          background-color: #fef4f4;
        }
        &.active {
          &::before {
            content: "";
            width: 4px;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            background-color: #a13838;
          }
        }
        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
  .container_right {
    flex: 1;
    overflow: hidden;
    .title {
      height: 46px;
      padding: 0 20px;
      background-color: #fef4f4;
      font-size: 18px;
      color: #666;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .text {
        display: flex;
        align-items: center;
        &::before {
          content: "";
          width: 4px;
          height: 16px;
          background-color: #a13838;
          margin-right: 10px;
        }
      }
      .breadcrumb {
        font-size: 14px;
        .icon-shouye {
          color: #a13838;
          margin-right: 5px;
        }
        span {
          color: #999;

          &.item {
            cursor: pointer;
            &:hover {
              color: #a13838;
              &::after {
                color: #999;
              }
            }
            &::after {
              content: " > ";
            }
            &:last-child {
              &::after {
                display: none;
              }
            }
          }
        }
      }
    }
    .detail {
      padding: 20px 0;
      .detail_title {
        padding: 0 60px;
        color: #a13838;
        font-size: 30px;
        font-weight: bold;
        text-align: center;
      }
      .detail_info {
        margin-top: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 15px;
        border-bottom: 1px #e6e6e6 dashed;
        color: #999;
        p {
          margin-right: 25px;
          &:last-child {
            margin-right: 0px;
          }
        }
      }
      .detail_con {
        margin-top: 30px;
        img {
          max-width: 100%;
        }
      }
    }
  }
}
</style>
